'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n        padding: 20px;\n      '], ['\n        padding: 20px;\n      ']),
    _templateObject2 = _taggedTemplateLiteral(['\n        padding: 0px;\n      '], ['\n        padding: 0px;\n      ']),
    _templateObject3 = _taggedTemplateLiteral(['\n        padding: 20px 0px;\n      '], ['\n        padding: 20px 0px;\n      ']),
    _templateObject4 = _taggedTemplateLiteral(['\n        padding: 0px 20px;\n      '], ['\n        padding: 0px 20px;\n      ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  width: 100%;\n  border-style: ', ' none none none;\n  border-width: 1px;\n  border-color: ', ';\n  ', ';\n'], ['\n  width: 100%;\n  border-style: ', ' none none none;\n  border-width: 1px;\n  border-color: ', ';\n  ', ';\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles


var setPadding = function setPadding(_ref) {
  var padding = _ref.padding;

  switch (padding) {
    case 'all':
      return (0, _styledComponents.css)(_templateObject);

    case 'none':
      return (0, _styledComponents.css)(_templateObject2);

    case 'vertical':
      return (0, _styledComponents.css)(_templateObject3);

    case 'horizontal':
      return (0, _styledComponents.css)(_templateObject4);

    default:
      return (0, _styledComponents.css)(_templateObject);
  }
};

var CardContent = _styledComponents2.default.div(_templateObject5, function (_ref2) {
  var noBorder = _ref2.noBorder;
  return noBorder ? 'none' : 'solid';
}, _colors.grey, setPadding);

CardContent.propTypes = {
  padding: _propTypes2.default.oneOf(['none', 'all', 'vertical', 'horizontal']),
  noBorder: _propTypes2.default.bool
};
CardContent.defaultProps = {
  padding: 'all',
  noBorder: false
};
exports.default = CardContent;